export default __webpack_public_path__ + "locales/zh-CN/Settings.json?hash=c99ad99fd3c31d3b8baa4588a05dd745";